import { render, staticRenderFns } from "./SftpDetailsDialogForCasualRecipients.vue?vue&type=template&id=67685072&scoped=true&"
import script from "./SftpDetailsDialogForCasualRecipients.vue?vue&type=script&lang=js&"
export * from "./SftpDetailsDialogForCasualRecipients.vue?vue&type=script&lang=js&"
import style0 from "./SftpDetailsDialogForCasualRecipients.vue?vue&type=style&index=0&id=67685072&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67685072",
  null
  
)

export default component.exports